<template>
  <div class="position-relative">
    <div v-if="loading" class="bpm-overlay">
      <span class="indicator-progress d-flex flex-column align-items-center text-success">
        <span class="spinner-border spinner-border-lg mb-2" aria-hidden="true"></span>
        <span>Подождите...</span>
      </span>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div v-if="message" class="alert alert-danger">
          {{ message }}
        </div>
        <input-mask-field
          v-model="phone"
          id="phone"
          name="phone"
          :required="true"
          :mb="5"
          placeholder="Номер телефона"
          mask="+7 (###) ###-##-##"
        />
        <button
          class="btn btn-lg btn-primary w-100"
          @click="submitPhone"
          :disabled="!isPhoneValid || loading"
        >
          Подтвердить телефон
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import InputMaskField from '@/components/Fields/InputMaskField'

export default {
  name: 'ProcessBpmPhoneConfirm',
  components: {
    InputMaskField
  },
  props: {
    process: {
      type: Object,
      required: true
    }
  },
  emits: ['update-process', 'close-modal'],
  data() {
    return {
      phone: '',
      message: '',
      loading: false
    }
  },
  mounted() {
    const params = this.process.process_data?.params
    this.message = params?.message ?? ''
    this.phone = (params?.phone ?? '').replace(/\D/g, '')
  },
  computed: {
    phoneDigits() {
      return this.phone.replace(/\D/g, '')
    },
    isPhoneValid() {
      const digits = this.phoneDigits
      return digits.length === 10 || (digits.length === 11 && digits.startsWith('7'))
    }
  },
  methods: {
    normalizePhoneForSubmit() {
      const digits = this.phoneDigits
      if (digits.length === 11 && digits.startsWith('7')) {
        return digits.slice(1)
      }
      return digits
    },
    submitPhone() {
      if (this.loading) return
      this.loading = true
      const params = {
        id: this.process.process_data.id,
        data: this.normalizePhoneForSubmit()
      }
      axios.post('/api/v2/process/bpm/send', params)
        .then(res => {
          if (res.data.result) {
            this.$emit('update-process', res.data.data, this.process.id)
            this.$emit('close-modal')
          } else {
            this.$notifyError(res.data)
          }
        })
        .catch(err => {
          this.$notifyError(err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.bpm-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 0.475rem;
}
</style>
